export default __webpack_public_path__ + "static/ping-exchange-thumbnail-776e870e9b2b382430788bd39ae05a00.png";